import { DataGrid, GridOverlay } from "@mui/x-data-grid"
import { dataGridSx } from "./styles";
import { Box } from "@mui/material";

function CustomNoRowsOverlay({emptyString}){
  return(
    <GridOverlay>
      <Box>
          {emptyString}
      </Box>
    </GridOverlay>
  )
}

const DataTable = ({rows, columns, emptyString = "Nenhum dado encontrado"}) => {
  return (
    <DataGrid
      disableColumnMenu
      autoHeight
      rowSelection={false}
      rows={rows}
      columns={columns}
      sx={dataGridSx}
      pageSizeOptions={[5]}
      slots={{ noRowsOverlay: CustomNoRowsOverlay }}
      slotProps={{
        noRowsOverlay: {
          emptyString
        }
      }}
      initialState={{
        pagination: {
          paginationModel: { pageSize: 5, page: 0 },
        }
      }}
      localeText={{
        MuiTablePagination: {
          labelDisplayedRows: ({ from, to, count }) =>
            `${from}–${to} de ${count}`,
            labelRowsPerPage: 'Linhas por página:',
        },
      }}
    />
  )
}

export default DataTable